import { Button } from "@mui/material";
import { useSearchId } from "hooks/search";
import { useNavigateToPlan } from "hooks/navigation";
import ZoomOutMapIcon from "@mui/icons-material/ZoomOutMap";
import { useTenantTranslation } from "hooks/formatters";
import { usePlanId } from "../../common/boundary/PlanId";

export const OpenInPage = () => {
  const { t } = useTenantTranslation();
  const navigateToPlan = useNavigateToPlan();

  const planId = usePlanId();
  const searchId = useSearchId();
  return (
    <Button
      startIcon={<ZoomOutMapIcon />}
      onClick={() => {
        if (searchId !== null) {
          navigateToPlan(planId, searchId);
        }
      }}
    >
      {t("openInPage")}
    </Button>
  );
};
